import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import TelecomDto from '../dto/TelecomDto'
import GenericReferencialDto from '../../../dto/GenericReferencialDto'
import Select from '../../../../components/forms/Select'
import Input from '../../../../components/forms/Input'
import Textarea from '../../../../components/forms/Textarea'
import { getDefaultValuesChoiceModal, getMatTypes } from '../../../../utils/MaterielUtils'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import PowerSupplyTypeDto from '../../powerSupply/dto/PowerSupplyTypeDto'
import { Grid } from '@mui/material'

const TelecomEquipmentPanel = ({
    telecom = {},
    telecomTypes = [],
    powerSupplyTypes = [],
    active = false,
    disabled = true,
    displayDesiccant = true,
    displaySupply = true,
    onChange = () => { },
}) => (
    <Grid size={12} sx={{ marginBottom: 1 }}>
        <Grid container spacing={1} sx={{ alignItems: 'center', paddingTop: '3px' }}>
            <Grid size={4}>
                <Select
                    options={getMatTypes(telecomTypes, telecom.telecomType)}
                    label={i18n.telecomType}
                    obligatory
                    onChange={value => {
                        onChange({ telecomType: value })
                        getDefaultValuesChoiceModal(telecomTypes.find(c => c.materielType == value), onChange)
                    }}
                    value={telecom.telecomType}
                    nullLabel='&nbsp;'
                    active={active}
                    disabled={disabled}
                />
            </Grid>
            <Grid size={4}>
                <Input
                    title={i18n.imeiAndSerialNumber}
                    value={telecom.imei}
                    onChange={value => onChange({ imei: value })}
                    active={active}
                    obligatory
                    disabled={disabled}
                />
            </Grid>
            <Grid size={4}>
                <Checkbox
                    label={i18n.digitalLineOrRTC}
                    checked={telecom.digitalLine}
                    onChange={value => onChange({ digitalLine: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ alignItems: displayDesiccant && displaySupply ? 'center' : undefined, paddingTop: '3px' }}>
            {
                displaySupply && (
                    <Grid container size={9} spacing={1}>
                        <Grid size={4}>
                            <Select
                                options={getMatTypes(powerSupplyTypes, telecom.powerSupplyType)}
                                label={i18n.powerSupplyType}
                                onChange={value => onChange({ powerSupplyType: value })}
                                value={telecom.powerSupplyType}
                                nullLabel='&nbsp;'
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid size={4}>
                            <NumberField
                                title={i18n.batteryCount}
                                value={telecom.pileNumber}
                                onChange={value => onChange({ pileNumber: value })}
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid size={4}>
                            <NumberField
                                title={i18n.supplyTime}
                                value={telecom.supplyTime}
                                onChange={value => onChange({ supplyTime: value })}
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                    </Grid>
                )
            }
            {
                displayDesiccant && (
                    <Grid size={3}>
                        <Checkbox
                            label={i18n.desiccant}
                            checked={telecom.desiccant === '1'}
                            onChange={value => onChange({ desiccant: value ? '1' : '0' })}
                            active={active}
                            disabled={disabled}
                        />
                    </Grid>
                )
            }
        </Grid>
        <Grid container sx={{ paddingTop: telecom.closeDate ? '3px' : '8px' }}>
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={telecom.comment}
                    onChange={value => onChange({ comment: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
    </Grid >
)

TelecomEquipmentPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    displayDesiccant: PropTypes.bool,
    displaySupply: PropTypes.bool,
    telecom: PropTypes.instanceOf(TelecomDto),
    telecomTypes: PropTypes.arrayOf(GenericReferencialDto),
    powerSupplyTypes: PropTypes.arrayOf(PropTypes.instanceOf(PowerSupplyTypeDto)),
}

const mapStateToProps = store => ({
    telecomTypes: store.TelecomReducer.telecomTypes,
    powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
})

export default connect(mapStateToProps)(TelecomEquipmentPanel)
